<div class="row">
  <div class="col-12 col-md-7">
    <div [ngBusy]="recentlyViewedBusyConfig">
      <app-product-list blockTitle="Recently viewed products"
                        emptyMessage="You did not view any products yet"
                        linkId="recently-viewed-"
                        [products]="recentlyViewedProducts"
                        [isClientLink]="true">
      </app-product-list>
    </div>
  </div>
  <div class="col-12 col-md-5">
    <div [ngBusy]="lastEditedBusyConfig">
      <app-product-list blockTitle="Your last edited products"
                        emptyMessage="You haven't edited any products in the last 90 days"
                        linkId="last-edited-"
                        [products]="lastEditedProds"
                        [isClientLink]="false">
      </app-product-list>
    </div>
    <div [ngBusy]="recentlyReleasedBusyConfig">
      <app-product-list blockTitle="Your new releases"
                        subtitle="You have edited earlier versions of these products"
                        emptyMessage="No new releases that fit the criteria within the last 90 days"
                        linkId="recent-released-"
                        [products]="recentlyReleasedProds"
                        [isClientLink]="false">
      </app-product-list>
    </div>
  </div>
</div>
